import { render, staticRenderFns } from "./friendRoom.vue?vue&type=template&id=7defebdc&scoped=true"
import script from "./friendRoom.vue?vue&type=script&lang=js"
export * from "./friendRoom.vue?vue&type=script&lang=js"
import style0 from "./friendRoom.vue?vue&type=style&index=0&id=7defebdc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7defebdc",
  null
  
)

export default component.exports